import { InMemoryCache } from "@apollo/client";

let APP_URL = window.location.hostname;
if (APP_URL.includes('www.'))
    APP_URL = APP_URL.split('www.')[1];

const API_URL = process.env.MIX_API_URL || `https://api.${APP_URL}/graphql`;

export const cache = new InMemoryCache({
    uri: API_URL,
    // typePolicies: {
    //     Query: {
    //         // keyFields: ['vehicleSearchTerm'],
    //         fields: {
    //             listVehicles: {
    //                 keyArgs: false,
    //                 merge(existing, incoming) {
    //                     console.log('merge: existing', existing);
    //                     console.log('merge: incoming', incoming);
    //                     if (!incoming) return existing
    //                     if (!existing) return incoming // existing will be empty the first time 

    //                     const { vehicles, ...rest } = incoming;
    //                     let result = rest;

    //                     if (existing.vehicles)
    //                         result.vehicles = _.uniqBy([...existing.vehicles, ...vehicles], '__ref'); // Merge existing items with the items from incoming
    //                     else
    //                         result.vehicles = vehicles;

    //                     console.log('merge: result', result);
    //                     return result;
    //                 },
    //             }
    //         }
    //     },
    //     ListVehiclesGraphQL: {
    //         keyFields: []
    //     }
    // }
});